import React, { useState } from 'react';
import styled from 'styled-components';

interface FeedbackBlockProps {
    onSubmit?: (feedback: string) => void;
}

const Feedback = styled.div`
  background: #f9f9f9;
  padding: 2rem;
  border-radius: 8px;
  
  h3 {
    margin-bottom: 1rem;
  }
`;

const FeedbackForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  
  textarea {
    padding: 1rem;
    border: 1px solid #ddd;
    border-radius: 4px;
    min-height: 100px;
  }
  
  button {
    background: #28a745;
    color: white;
    border: none;
    padding: 1rem;
    border-radius: 4px;
    cursor: pointer;
    
    &:hover {
      background: #218838;
    }
  }
`;

const FeedbackBlock: React.FC<FeedbackBlockProps> = ({ onSubmit }) => {
    const [feedback, setFeedback] = useState('');

    const handleFeedbackSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        onSubmit?.(feedback);
        setFeedback('');
    };

    return (
        <Feedback>
            <h3>Вам помогло?</h3>
            <p>Поделитесь своим мнением о статье</p>
            <FeedbackForm onSubmit={handleFeedbackSubmit}>
                <textarea
                    value={feedback}
                    onChange={(e) => setFeedback(e.target.value)}
                    placeholder="Что вам понравилось или что не хватило?"
                />
                <button type="submit">Отправить отзыв</button>
            </FeedbackForm>
        </Feedback>
    );
};

export default FeedbackBlock; 